import Bloc from './Bloc.js';
import Types from './Types.js';
import Card from '../Card.js';

export default class Morph extends Bloc {

	constructor (src, ctx) {

		super("morph", src, ctx, true);
		this.f = (src, ins) => {
			let location = ins[0].location;
			var tier = ins[2] === null ? 1 : ins[2];
			const model = tier > 1 ? Object.assign({}, ins[1], {tier}, ins[1].upgrades[tier-2]) : ins[1];
			if (location.type === "court") {
				if (ins[0].ethereal)
					return [];
				location = ins[0].master.discard;
			}
			ins[0].exile();
			let gen = new Card(src.master, model);
			location.addCard(gen);
			src.master.notify("cardmorph", gen, ins[0], model);
			return [gen];
		};
		this.types = [Types.card, Types.model, Types.int];
	}
}